'use client';
import React from 'react';
import DashboardTopbar from './components/DashboardTopbar';
import SessionStatusBar from './components/SessionStatusBar';
import SignalGeneratorSection from './components/SignalGeneratorSection';
import SignalHistorySection from './components/SignalHistorySection';
import TradingViewChart from './components/TradingViewChart';
import XauPriceTicker from './components/XauPriceTicker';
import { Toaster } from 'sonner';
import { useLanguage } from '@/contexts/LanguageContext';
import RiskDisclaimerModal from './components/RiskDisclaimerModal';

export default function TradingSignalsDashboard() {
  const { t } = useLanguage();

  return (
    <div className="xau-page-bg min-h-screen bg-[#09090f] scanline">
      <RiskDisclaimerModal />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#18181f',
            border: '1px solid rgba(212,175,55,0.2)',
            color: '#f5f5f5',
            fontFamily: 'Geist, sans-serif',
            fontSize: '14px',
          },
        }}
      />
      <DashboardTopbar />
      <SessionStatusBar />
      <main className="max-w-screen-2xl mx-auto px-3 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 py-4 sm:py-6 space-y-4 sm:space-y-8">
        <XauPriceTicker />
        <SignalGeneratorSection />

        {/* Recommended Broker — soft recommendation only, not mandatory */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 rounded-xl border border-[#d4af37]/20 bg-[#d4af37]/5 px-5 py-4">
          <div className="flex items-start gap-3">
            <span className="mt-0.5 text-[#d4af37] text-lg">★</span>
            <div>
              <p className="text-xs font-semibold uppercase tracking-widest text-[#d4af37] mb-1">Recommended Broker</p>
              <p className="text-sm text-zinc-300 leading-relaxed">
                We recommend using <span className="text-[#d4af37] font-medium">Exness</span> for optimal execution and spread conditions, as our engine was built and tested using this broker.
              </p>
            </div>
          </div>
          <a
            href="https://one.exnessonelink.com/a/sgqc86zkqc"
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 inline-flex items-center gap-2 rounded-lg border border-[#d4af37]/40 bg-[#d4af37]/10 hover:bg-[#d4af37]/20 text-[#d4af37] text-sm font-semibold px-5 py-2.5 transition-colors duration-200"
          >
            Open Account
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </a>
        </div>

        <TradingViewChart />
        <SignalHistorySection />
      </main>
      <footer className="max-w-screen-2xl mx-auto px-3 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 py-4 sm:py-6 border-t border-white/5 mt-4 sm:mt-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-zinc-600 font-mono">
            {t('footerVersion')}
          </p>
          <p className="text-xs text-zinc-600 text-center">
            {t('footerInfo')}
          </p>
          <p className="text-xs text-zinc-600 font-mono">
            {t('footerPair')}
          </p>
        </div>
      </footer>
    </div>
  );
}